import React from 'react'

export const maineSetupVars = {
  siteId: 'maine',
  pathPrefix: '/me',
  menuHeader: "Discover Maine's Solution for:",
  appUrl: 'https://me.headed2.com',
  logoImg: '/images/assets/maine/horizontal/dark.svg',
  headerTitle: `The Maine CareerExplorer is a system designed for Maine`
}
